import React from 'react';
import { Badge } from 'react-bootstrap';

import useUser from '../hooks/useUser';

export default function InvoiceStatusBadge(data) {
  const { user } = useUser();
  const status = user.is_shop ? data.invoiceData.status_merchant : data.invoiceData.status_customer;

console.log(status)

  const badgeStyle = () => {
    switch (status) {

      // Merchant states
      case "sent":
        return "info";
      case "pending":
        return "warning";
      case "deposited":
        return "success";

      // Customer states
      case "billed":
        return "info";
      case "paying":
        return "warning";
      case "paid":
        return "success";

      // All 
      case "reversed":
        return "secondary";
    }
  }

  const textStyle = () => {
    if (badgeStyle() === "warning" ) {
      return "dark";
    }
  }
  
  return (
    <Badge pill bg={badgeStyle()} text={textStyle()}>
      {status}
    </Badge>
  )
}